import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import { PlatformErrorBoundary } from "../PlatformErrorBoundary";
import AdminMetrics from "../widgets/AdminMetrics";
import AdminFinanceWidget from "../widgets/AdminFinanceWidget";
import CompanyAppsStatusBoard from "../CompanyAppsStatusBoard";
import CompanyTeamManagement from "../CompanyTeamManagement";
import CompanyActivityLogPanel from "../CompanyActivityLogPanel";
import AlertsOverviewWidget from "../widgets/AlertsOverviewWidget";
import AppsHealthWidget from "../widgets/AppsHealthWidget";
import ExternalLinksSnapshotWidget from "../widgets/ExternalLinksSnapshotWidget";
import TicketSummaryWidget from "../widgets/TicketSummaryWidget";

const AdminDashboard = () => {
  return (
    <PlatformErrorBoundary>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>

        <Grid container spacing={3}>
          {/* Navigation / Quick Links */}
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Admin Tools
              </Typography>
              <List>
                <ListItem
                  button
                  component={Link}
                  to="/admin/workspace-settings"
                >
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Workspace Settings" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to="/admin/apps-and-sites"
                >
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Apps & Sites" />
                </ListItem>
                {/* Chat Settings lives under Operations in the global Sidebar */}
              </List>
            </Paper>
          </Grid>

          {/* Widgets Grid */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} lg={4}>
                <AdminMetrics />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <AdminFinanceWidget />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <AppsHealthWidget />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <AlertsOverviewWidget />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <TicketSummaryWidget />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <ExternalLinksSnapshotWidget />
              </Grid>
            </Grid>
          </Grid>

          {/* Full-width sections */}
          <Grid item xs={12}>
            <CompanyAppsStatusBoard />
          </Grid>
          <Grid item xs={12}>
            <CompanyTeamManagement />
          </Grid>
          <Grid item xs={12}>
            <CompanyActivityLogPanel />
          </Grid>
        </Grid>
      </Box>
    </PlatformErrorBoundary>
  );
};

export default AdminDashboard;
